import { Button, Badge } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux';
import React, { useState, useEffect } from "react";
import SendPricingRate from "../../../Modal/SendPricingRate"
import { getPricingDataFormatted } from '../../../DynamicTable/tilesData/pricing';
import { UPDATE_STATE } from "../../../../actions/types";
import { APP_CACHE } from '../../../../app/config';
const SendRatesButton = (props) => {
    const { app_state, ui_state } = useSelector(state => state.app.current_state);
    const { isRoomTypePricing } = app_state.workspace_controls;
    const [numRatesChanged, setNumRatesChanged] = useState(0);
    const dispatch = useDispatch();

    useEffect(() => {
        let ratesChanged = 0;
        const pricingData = getPricingDataFormatted(app_state, true);
        if (isRoomTypePricing === false) {
            Object.keys(app_state.pricing_override_rates).map(key => {
                if (app_state.pricing_override_rates[key].approved === true) {
                    ratesChanged += 1;
                }
            })
        } else {

            Object.keys(app_state.roomtype_pricing_overrides).map(stay_date => {
                // let dayData = {};
                // pricingData.map(item => {
                //     if (item.stay_date === stay_date) {
                //         dayData = item;
                //     }
                // });
                // Object.keys(app_state.roomtype_pricing_overrides[stay_date]).map(room_code => {
                //     if (app_state.roomtype_pricing_overrides[stay_date][room_code].SellRate) {
                //         // pricingData
                //         if (dayData[room_code] && dayData[room_code].SellRate !== app_state.roomtype_pricing_overrides[stay_date][room_code].SellRate) {
                //             ratesChanged += 1;
                //         }

                //     }
                //     // ratesChanged += 1;
                // })
                Object.keys(app_state.roomtype_pricing_overrides[stay_date]).map(room_code => {
                    if (app_state.roomtype_pricing_overrides && app_state.roomtype_pricing_overrides[stay_date][room_code].previous_data && app_state.roomtype_pricing_overrides[stay_date][room_code].SellRate) {
                        if(app_state.roomtype_pricing_overrides[stay_date][room_code].SellRate !== app_state.roomtype_pricing_overrides[stay_date][room_code].previous_data.SellRate ){
                            ratesChanged += 1;
                        }
                        // if(!dayData[room_code]){
                        //     ratesChanged+=1;
                        // }

                    }
                })

            })
        }

        setNumRatesChanged(ratesChanged);
        return () => {

        }
    }, [app_state.pricing_override_rates, app_state.roomtype_pricing_overrides, app_state.workspace_controls, ui_state.pricingRateModalOpen])
    const handleClick = () => {
        if (numRatesChanged > 0) {
            console.log("clicked ");
            APP_CACHE.pricingRateModalOpen =true;
            dispatch({
                type: UPDATE_STATE, payload: { ui_state: { pricingRateModalOpen: true } }
            });
        }
    }

    return (
        <>
            <Badge component="div" classes={{ badge: 'pulse' }} badgeContent={numRatesChanged} color="primary" className='btn-ratepush' sx={{ mt: 0, mr: 0, position: 'relative' }}>
                <Button disabled={(numRatesChanged < 1)} className=' PushRateButton' size="small" sx={{ m: "auto" }} onClick={handleClick}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 14 11" fill="none">
                        <path d="M13.5623 5.50001C13.5651 6.5419 13.2271 7.55612 12.5998 8.38806C12.5653 8.43402 12.522 8.47273 12.4725 8.50197C12.423 8.53122 12.3682 8.55042 12.3113 8.5585C12.2544 8.56657 12.1964 8.56336 12.1407 8.54903C12.0851 8.53471 12.0327 8.50955 11.9868 8.47501C11.9408 8.44046 11.9021 8.39721 11.8729 8.3477C11.8436 8.2982 11.8244 8.24342 11.8163 8.18649C11.8083 8.12957 11.8115 8.07161 11.8258 8.01592C11.8401 7.96024 11.8653 7.90792 11.8998 7.86196C12.4132 7.18178 12.6898 6.3522 12.6873 5.50001C12.6873 4.45572 12.2725 3.4542 11.5341 2.71578C10.7956 1.97735 9.79412 1.56251 8.74983 1.56251C7.70554 1.56251 6.70402 1.97735 5.96559 2.71578C5.22717 3.4542 4.81233 4.45572 4.81233 5.50001C4.81233 5.61604 4.76623 5.72732 4.68419 5.80937C4.60214 5.89141 4.49086 5.93751 4.37483 5.93751C4.2588 5.93751 4.14752 5.89141 4.06547 5.80937C3.98342 5.72732 3.93733 5.61604 3.93733 5.50001C3.93711 5.0585 3.99766 4.61907 4.11725 4.19407C4.05764 4.18751 3.99748 4.18751 3.93733 4.18751C3.24113 4.18751 2.57346 4.46407 2.08117 4.95635C1.58889 5.44864 1.31233 6.11631 1.31233 6.81251C1.31233 7.5087 1.58889 8.17638 2.08117 8.66866C2.57346 9.16095 3.24113 9.43751 3.93733 9.43751H5.24983C5.36586 9.43751 5.47714 9.4836 5.55919 9.56565C5.64123 9.6477 5.68733 9.75898 5.68733 9.87501C5.68733 9.99104 5.64123 10.1023 5.55919 10.1844C5.47714 10.2664 5.36586 10.3125 5.24983 10.3125H3.93733C3.45617 10.3126 2.98016 10.2135 2.53903 10.0214C2.09789 9.82929 1.70111 9.54828 1.37345 9.19593C1.0458 8.84357 0.794314 8.42745 0.634704 7.97354C0.475095 7.51963 0.410789 7.03768 0.445804 6.55781C0.480818 6.07793 0.614401 5.61042 0.838209 5.18449C1.06202 4.75855 1.37124 4.38334 1.74657 4.08228C2.12191 3.78123 2.55528 3.56079 3.01963 3.43474C3.48398 3.30869 3.96933 3.27974 4.44537 3.3497C4.93012 2.38017 5.72798 1.60269 6.70972 1.14318C7.69146 0.683674 8.79958 0.569053 9.85459 0.817886C10.9096 1.06672 11.8497 1.66443 12.5226 2.51421C13.1956 3.36398 13.5619 4.41605 13.5623 5.50001ZM8.62186 5.19048C8.58123 5.1498 8.53298 5.11753 8.47987 5.09551C8.42675 5.0735 8.36982 5.06216 8.31233 5.06216C8.25483 5.06216 8.1979 5.0735 8.14479 5.09551C8.09168 5.11753 8.04343 5.1498 8.0028 5.19048L6.2528 6.94048C6.21215 6.98112 6.1799 7.02938 6.15791 7.08249C6.13591 7.1356 6.12458 7.19252 6.12458 7.25001C6.12458 7.30749 6.13591 7.36442 6.15791 7.41753C6.1799 7.47063 6.21215 7.51889 6.2528 7.55954C6.33489 7.64163 6.44623 7.68775 6.56233 7.68775C6.61981 7.68775 6.67674 7.67643 6.72985 7.65443C6.78295 7.63243 6.83121 7.60019 6.87186 7.55954L7.87483 6.55602V9.87501C7.87483 9.99104 7.92092 10.1023 8.00297 10.1844C8.08502 10.2664 8.1963 10.3125 8.31233 10.3125C8.42836 10.3125 8.53964 10.2664 8.62169 10.1844C8.70374 10.1023 8.74983 9.99104 8.74983 9.87501V6.55602L9.7528 7.55954C9.79345 7.60019 9.8417 7.63243 9.89481 7.65443C9.94792 7.67643 10.0048 7.68775 10.0623 7.68775C10.1198 7.68775 10.1767 7.67643 10.2298 7.65443C10.283 7.63243 10.3312 7.60019 10.3719 7.55954C10.4125 7.51889 10.4448 7.47063 10.4668 7.41753C10.4887 7.36442 10.5001 7.30749 10.5001 7.25001C10.5001 7.19252 10.4887 7.1356 10.4668 7.08249C10.4448 7.02938 10.4125 6.98112 10.3719 6.94048L8.62186 5.19048Z" fill="#606060" />
                    </svg>
                    Update
                </Button>
            </Badge>
            <SendPricingRate  />

        </>
    )

}


export default SendRatesButton